import { LayerType } from "../../types";
import { ConstraintsLayerType } from "../ConstraintsLayerType";
import { SubstationSelectionSidebar } from "./SubstationSelectionSidebar";
import { substationClickResolver } from "./substationClickResovler";
import { SubstationLayerSummary } from "./SubstationLayerSummary";

export const SubstationLayerType: LayerType = {
  ...ConstraintsLayerType,
  LayerSummary: SubstationLayerSummary,
  Printable: undefined,
  clickResolver: substationClickResolver,
  SelectionSidebar: SubstationSelectionSidebar,
};
